const BRAND_CODES = {
  privacyShield: 'privacy',
  privacyMedicalShield: 'psms',
  missGroupSafe: 'mgsafe',
  domeneShop: 'dshop',
  domainkeskusSafe: 'dsafe',
  partyhat: 'partyhat',
  protectIV: 'protectiv',
  phSafe: 'phsafe',
  identityDefense: 'iddefense',
  myPrivacyAssist: 'boapa',
  medicalShield: 'mshield',
  minorDefense: 'dminor',
  enguard: 'enguard',
  financialShield: 'afs2',
  homeTitleGuardian: 'hometitle',
  totalAv: 'totalav',
  ultraAv: 'ultraav',
  anpac: 'anpac',
  aolidg: 'aolidg',
  creditnotify: 'creditnotify',
  idguard: 'idguard',
  barclays: 'barclays',
  creditmon: 'creditmon',
  bofwest: 'bofwest',
  comerica: 'comerica',
  discover: 'discover',
} as const;

export default BRAND_CODES;
